import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource';
import VueRouter from 'vue-router';
import { routes } from './routes';
import './directives/Transform';
import VeeValidate from 'vee-validate';
import VueBrowserUpdate from 'vue-browserupdate';
import msg from './pt_BR';
import './assets/css/material-icons/material-icons.css';
import * as VueGoogleMaps from 'vue2-google-maps';

import './assets/js/materialize.js';
//import './assets/css/materialize-custom.css';
//import './assets/css/materialize-mto.css';
//import './assets/js/custom-materialize.js';
// import './assets/js/init.js';

Vue.use(VueResource);
// Vue.http.options.root = 'http://localhost:8080/trueb2b/webapi';
Vue.http.options.root = 'webapi';


Vue.http.interceptors.push((request, next) => {
  next((response) => {  
    if(response.status == 0) {      
      response.body = {title:'Sem conexão com o servidor.', detail: 'Não foi possível estabelecer uma conexão com o servidor, entre em contato com a equipe de administração de infra ou tente novamente mais tarde.'};
      response.bodyText = {title:'Sem conexão com o servidor.', detail: 'Não foi possível estabelecer uma conexão com o servidor, entre em contato com a equipe de administração de infra ou tente novamente mais tarde.'};            
    };
  })
});

Vue.use(VueRouter);

Vue.use(VueGoogleMaps, {
  load: {
    key:'AIzaSyADodBHNIMVmZ1ZpdtHNEGgsugAzELQx6o',
    libraries: 'visualization'
  }
});

const router = new VueRouter({ 
  routes,
  linkActiveClass:'active'
  /*, 
  mode: 'history'*/
});

Vue.use(VeeValidate, {
  locale: 'pt_BR',
  dictionary: {
    pt_BR: {
      messages: msg
    }
  }
});

Vue.use(VueBrowserUpdate, {
  options: {
      // Your browser update options
      notify:{i:-1,f:-2,o:-2,s:-1,c:-2},
      insecure:true,
      api:5,
      container: document.body,
  },
});
 

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js